<template>
  <div class="betting-wrapper pull-left">
    <div class="betting-content clearfix">
      <div class="bet-title-wrapper">
        <label class="bet-title">{{'ticket' | translate}}</label>
      </div>
      <form name="virtualForm" class="pull-left">
          <div id="bet-area" class="inputs-wrapper">
              <div class="betting-inputs">
                  <label class="input-label">{{'matchId' | translate}}</label>
                  <input type="text"
                         id="matchId"
                         name="matchId"
                         class="input-default input"
                         ref="inputs.matchId"
                         v-model="inputs.matchId"
                         :maxlength="9"
                         :disabled="disabledInputMatchId"
                         tabindex="1"
                         @keypress="checkIsNumber($event)"
                         @keyup.exact="checkOffer('match', inputs.matchId)"
                         @keyup.enter.stop="setFocus('match')"
                         >
              </div>
              <div class="betting-inputs">
                  <label class="input-label">{{'betId' | translate}}</label>
                  <input type="text"
                         id="betId"
                         name="betId"
                         class="input-default input"
                         ref="inputs.betId"
                         v-model="inputs.betId"
                         :maxlength="9"
                         :disabled="!foundMatch"
                         tabindex="2"
                         @keypress="checkIsNumber($event)"
                         @keyup.exact="checkOffer('bet', inputs.betId)"
                         @keyup.enter="setFocus('bet')"
                         >
                         <!-- Special bet -->

                         <div v-if="search.possibleBets.length > 1 && valid.bet"
                           class="special-value-bet">
                           <div class="special-value-dropdown">
                             <span class="n-i n-i-arrow-up-b2 arrow-value-up"></span>
                             <input type="text"
                                    name="specialBet"
                                    readonly
                                    class="input-default special-input"
                                    ref="inputs.defaultSpecBetVal"
                                    v-model="inputs.defaultSpecBetVal"
                                    :disabled="!foundSpecial"
                                    tabindex="3"
                                    @keyup.exact="checkOffer('specBet', inputs.defaultSpecBetVal)"
                                    @keyup.up.down.prevent="selectBet($event)"
                                    @keyup.enter.stop="setFocus('specBet')"
                                    >
                             <span class="n-i n-i-arrow-down-b2 arrow-value-down"></span>
                           </div>
                         </div>
                         <!-- END -->
              </div>
              <div class="betting-inputs">
                  <label class="input-label">{{'outcomeId' | translate}}</label>
                  <input type="text"
                         id="OutcomeId"
                         name="OutcomeId"
                         class="input-default input"
                         ref="inputs.outcomeId"
                         v-model="inputs.outcomeId"
                         :maxlength="9"
                         :disabled="!foundBet"
                         tabindex="4"
                         @keyup.exact="checkOffer('outcome', inputs.outcomeId)"
                         @keyup.enter="setFocus('outcome')"
                         >
                         <label class="input-msg input-msg-outcome-selected"
                                v-show="valid.bet && valid.outcome && inputs.outcomeId.length > 0">
                           {{inputs.outcomeOdd}}
                         </label>
              </div>
          </div>
        <span class="input-msg overflow-text"
               v-show="!valid.outcome && inputs.outcomeId.length > 0">
          {{error.outcome}}
        </span>
      </form>
      <div class="betting-preview pull-right">
        <div class="betting-preview-match">
          <span class="input-msg overflow-text" v-show="valid.match && !foundMatchInBetslip">
            {{inputs.matchName}}
          </span>
          <span class="input-msg overflow-text" v-show="!valid.match && inputs.matchId.length > 0">
            {{error.match}}
          </span>
        </div>
        <div class="input-msg overflow-text"
          v-show="!valid.bet && inputs.betId.length > 0">
          {{error.bet | translate}}
        </div>
        <div class="betting-preview-wrap"
          v-show="valid.bet"
          v-for="bet in search.possibleBets"
          v-bind:key="bet.betId">
          <div class="betting-preview-bet">
            <span class="input-msg overflow-text" >
              {{bet.betName | translate}}
            </span>
            <span>{{bet.betSpecialValue}}</span>
          </div>
        <div class="betting-preview-outcomes clearfix">
          <div class="betting-preview-outcome pull-left clearfix"
            :class="{'reduce-width': bet.betOutcomes.length > 7,
            'width': bet.betOutcomes.length <= 7}"
            v-for="outcome of bet.betOutcomes"
            v-bind:key="outcome.outcomeId"
            @click="addOutcome(bet, outcome)">
              <div class="betting-preview-outcome-type overflow-text pull-left"
                :class="{'active': outcome.outcomeType === selected.outcome.outcomeType &&
                outcome.outcomeId === selected.outcome.outcomeId}">
                {{outcome.outcomeShortcut}}
              </div>
              <div class="betting-preview-outcome-display-info pull-right clearfix"
                :class="{'active': outcome.outcomeType == selected.outcome.outcomeType &&
                outcome.outcomeId === selected.outcome.outcomeId}">
                <div class="betting-preview-outcome-display-info-name overflow-text pull-left">
                  {{outcome.outcomeShortName}}
                </div>
                <div class="betting-preview-outcome-display-info-odd overflow-text pull-right">
                  {{outcome.outcomeOdd}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import toNumber from 'lodash/toNumber';
import findIndex from 'lodash/findIndex';
import * as Ticket from '@/model/ticket';

export default {
  name: 'BettingBox',
  data() {
    return {
      inputs: {
        matchId: '',
        matchName: '',
        betId: '',
        betName: '',
        defaultSpecBetVal: '',
        outcomeId: '',
        outcomeOdd: '',
      },
      search: {
        match: {},
        bet: {},
        outcome: {},
        possibleBets: [],
        specialBetVal: [],
      },
      error: {
        match: '',
        bet: '',
        outcome: '',
      },
      valid: {
        match: true,
        bet: false,
        outcome: false,
      },
      disabledInputMatchId: false,
      foundMatch: false,
      foundBet: false,
      foundOutcome: false,
      foundSpecial: false,
      checkMatchInBetslip: false,
      foundMatchInBetslip: false,
      selectedBet: false,
      tmpResponse: {
        data: {},
        valid: false,
        multipleBets: false,
        specialBetName: '',
        error: {
          msg: '',
          params: {},
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      'offer',
      'selected',
      'bets',
      'bet',
      'editBet',
      'betTypes',
      'activeBetType',
      'translations',
      'isGameActive',
      'keyEventTimestamp',
      'gameConfig',
    ]),
  },
  mounted() {
    this.enableMatchInput();
  },
  methods: {
    ...mapActions([
      'addBet',
      'setMatch',
      'setBet',
      'setOutcome',
      'changeBet',
      'clearBets',
      'clearSelected',
      'sendMessage',
      'removeBet',
    ]),
    enableMatchInput() {
      this.disabledInputMatchId = false;
      this.$nextTick(() => {
        this.$refs['inputs.matchId'].focus();
      });
    },
    /**
     * Update input values after edit bet on betslip
     *
     * @param {object} data
     */
    updateInputs(data) {
      // console.log(' *** updateInputs ', data);
      this.inputs.matchId = Object.prototype.hasOwnProperty.call(data, 'matchDisplayId') ? data.matchDisplayId.toString() : '';
      this.inputs.betId = Object.prototype.hasOwnProperty.call(data, 'betDisplayId') ? data.betDisplayId.toString() : '';
      this.inputs.outcomeId = Object.prototype.hasOwnProperty.call(data, 'betOutcomeShortcut') ? data.betOutcomeShortcut.toString() : '';
      this.inputs.outcomeOdd = Object.prototype.hasOwnProperty.call(data, 'mboOddValue') ? data.mboOddValue.toString() : '';
      this.checkMatch(toNumber(this.inputs.matchId));
      // only if match is valid check bets and outcomes
      if (this.foundMatch) {
        this.checkBet(toNumber(this.inputs.betId));
        if (data.mbSpecialValue.length !== 0) {
          this.inputs.defaultSpecBetVal = Object.prototype.hasOwnProperty.call(data, 'mbSpecialValue') ? data.mbSpecialValue.toString() : '';
          this.checkSpecBet(this.checkInputVal(this.inputs.defaultSpecBetVal));
        }
        this.checkOutcome(this.checkInputVal(this.inputs.outcomeId));
      }
      this.enableMatchInput();
    },
    /**
     * Check if input value is number
     *
     * @param {object} evt
     * @returns {boolean}
     */
    checkIsNumber(evt) {
      let isNumber;
      const event = (!evt) ? window.event : evt;
      const keyCode = (event.which) ? event.which : event.keyCode;
      if ((keyCode > 31 && (keyCode < 48 || keyCode > 57))) {
        isNumber = false;
        evt.preventDefault();
      } else {
        isNumber = true;
      }
      return isNumber;
    },
    /**
     * Check input value with offer
     *
     * @param {string} type
     * @param {string} id
     */
    checkOffer(type, id) {
      // do not check offer if input value is empty
      if (id.toString().length === 0) {
        switch (type) {
          case 'match': {
            this.enableMatchInput();
            this.inputs.matchName = '';
            this.valid.bet = false;
            this.valid.outcome = false;
            this.setMatch({});
            break;
          }
          case 'bet': {
            this.$refs['inputs.betId'].focus();
            this.inputs.betName = '';
            this.valid.match = true;
            this.valid.bet = false;
            this.valid.outcome = false;
            this.foundBet = false;
            this.foundSpecial = false;
            this.inputs.outcomeId = '';
            this.setBet({});
            this.setOutcome({});
            break;
          }
          case 'specBet':
            this.$refs['inputs.defaultSpecBetVal'].focus();
            this.inputs.betName = '';
            this.valid.match = true;
            this.valid.bet = false;
            this.valid.outcome = false;
            this.foundBet = false;
            this.foundSpecial = false;
            this.setBet({});
            this.setOutcome({});
            break;
          case 'outcome': {
            this.inputs.outcomeId = '';
            this.inputs.outcomeOdd = '';
            this.setOutcome({});
            break;
          }
          // no default
        }
        return;
      }
      const inputVal = type === 'specBet' ? id : toNumber(id);
      switch (type) {
        case 'match':
          this.checkMatch(inputVal);
          break;
        case 'bet':
          this.checkBet(inputVal);
          break;
        case 'specBet':
          this.checkSpecBet(inputVal);
          break;
        case 'outcome':
          this.checkOutcome(id);
          break;
        default:
      }
    },
    checkInputVal(val) {
      return (typeof val === 'number') ? Number(val) : val;
    },
    /**
     * Check match Id
     *
     * @param {number} id
     */
    checkMatch(id) {
      this.search.match = this.findMatchById(id);
      this.setMatch(this.validateMatch(this.search.match, id));
    },
    /**
     * Search matches offer by input value
     *
     * @param {number} id
     * @returns {*}
     */
    findMatchById(id) {
      let matchDisplay = {};
      Object.keys(this.offer).forEach((key) => {
        if (this.offer[key].matchDisplayId === id) {
          this.inputs.matchName = this.offer[key].matchName;
          matchDisplay = this.offer[key];
          this.valid.match = true;
        }
      });
      return matchDisplay;
    },
    /**
     * Validate selected match
     *
     * @param {object} match
     * @param {number} id
     * @returns {*}
     */
    validateMatch(match, id) {
      this.foundMatch = false;
      if (!match || Object.keys(match).length === 0) {
        // There is no selected match
        this.error.match = `${this.translations.matchWithId ? this.translations.matchWithId : 'matchWithId'}
        ${id} ${this.translations.isNotFound ? this.translations.isNotFound : 'isNotFound'}`;
        // this.valid.match = this.selectedBet;
        this.resetValues();
      } else if (match.bettingStatus !== true) {
        // Betting is disabled
        this.error.match = this.selectedBet ? false : this.translations.matchIsDisabled || 'matchIsDisabled';
        this.resetValues();
        // this.valid.match = this.selectedBet;
        /* this.valid.bet = false;
        this.valid.outcome = false; */
      } else if (this.checkBetslip(id)) {
        // Match is already on betslip
        this.error.match = this.selectedBet ? false : this.translations.matchIsAlreadyPlayed || 'matchIsAlreadyPlayed';
        this.valid.match = this.selectedBet;
        this.valid.bet = false;
        this.valid.outcome = false;
      } else {
        this.foundMatch = true;
        this.valid.match = true;
        this.valid.bet = true;
        // this.inputs.betName = '';
      }
      return match;
    },
    /**
     * Check match bet Id
     *
     * @param {number} id
     */
    checkBet(id) {
      this.search.possibleBets = this.getBets(id);
      if (this.search.possibleBets.length <= 1) {
        // If one/none possible bet
        this.setBet(this.validateMatchBet(this.search.possibleBets[0]));
      } else {
        this.getpossibleBets();
      }
    },
    /**
     * Get bets for selected match
     *
     * @param {number} inputVal
     * @return {array}
     */
    getBets(inputVal) {
      const betArr = [];
      Object.keys(this.selected.match.matchBets).forEach((key) => {
        if (this.selected.match.matchBets[key].betDisplayId
          && (this.selected.match.matchBets[key].betDisplayId === inputVal)) {
          this.inputs.betName = this.selected.match.matchBets[key].betDisplayName;
          betArr.push(this.selected.match.matchBets[key]);
        }
      });
      return betArr;
    },
    /**
     * Get all special bets with same betDisplayId for sear possible bets
     */
    getpossibleBets() {
      this.valid.bet = true;
      this.search.specialBetVal = [];
      Object.keys(this.search.possibleBets).forEach((key) => {
        this.search.specialBetVal.push(this.search.possibleBets[key].betSpecialValue);
        this.foundBet = true;
        this.foundSpecial = true;
        this.valid.outcome = true;
      });
      [this.inputs.defaultSpecBetVal] = !this.inputs.defaultSpecBetVal
        ? this.search.specialBetVal : [this.inputs.defaultSpecBetVal];
    },
    /**
     * Validate selected bet
     *
     * @param {object} bet
     * @returns {*}
     */
    validateMatchBet(bet) {
      this.foundBet = false;
      if (!bet) {
        // There is no searched bet
        this.error.bet = this.translations.betIsNotFound || 'betIsNotFound';
        this.valid.bet = false;
        this.valid.outcome = false;
      } else {
        this.foundBet = true;
        this.valid.bet = true;
        this.valid.outcome = true;
      }
      return bet;
    },
    /* findMatchBetById(id) {
      this.foundBet = false;
      Object.keys(this.offer).forEach((key) => {
        const matchDisplay = this.offer[key];
        if (key !== 'type') {
          Object.keys(matchDisplay.matchBets).forEach((prop) => {
            const matchBetDisplay = matchDisplay.matchBets[prop];
            if (matchBetDisplay.betDisplayId && (matchBetDisplay.betDisplayId === id)) {
              this.inputs.betName = matchBetDisplay.betDisplayName;
              this.selected.bet = matchBetDisplay;
              this.foundBet = true;
            }
          });
        }
        return true;
      });
      return true;
    }, */
    /**
     * Check special bet Id
     *
     * @param {number} id
     */
    checkSpecBet(id) {
      this.search.bet = this.getSpecBets(id);
      this.setBet(this.validateMatchBet(this.search.bet));
    },
    getSpecBets(inputVal) {
      let specBetObj = {};
      for (let i = 0; i < this.search.possibleBets.length; i += 1) {
        if (this.search.possibleBets[i].betSpecialValue === inputVal) {
          specBetObj = this.search.possibleBets[i];
        }
      }
      /* for (let i = 0; i < this.search.specialBetVal.length; i += 1) {
        if (this.search.specialBetVal[i] === inputVal) {
          specBetObj = this.search.specialBetVal[i];
        }
      } */
      return specBetObj;
    },
    /**
     * Check outcome Id
     *
     * @param {number} id
     */
    checkOutcome(id) {
      this.search.outcome = this.getOutcome(id);
      this.setOutcome(this.validateBetOutcome(this.search.outcome));
    },

    /**
     * Get outcome for selected bet
     * @param {number} inputVal
     */
    getOutcome(inputVal) {
      let outcomeObj = {};
      for (let i = 0; i < this.selected.bet.betOutcomes.length; i += 1) {
        if (this.selected.bet.betOutcomes[i].outcomeShortcut === inputVal) {
          this.inputs.outcomeOdd = this.selected.bet.betOutcomes[i].outcomeOdd;
          outcomeObj = this.selected.bet.betOutcomes[i];
          this.foundOutcome = true;
        }
      }
      return outcomeObj;
    },
    /**
     * Validate outcome inside betslip, checking if this match => bet => outcome exist in betslip
     */
    validateBetOutcomeOnBetslip(outcome) {
      const index = findIndex(
        this.bets,
        bet => bet.idMatch === this.selected.match.idMatch
          && bet.betDisplayId === this.selected.bet.betDisplayId
          && bet.betOutcomeShortcut === outcome.outcomeShortcut,
      );
      // if (index >= 0) { this.removeBet(index); }
      return index >= 0;
    },
    /**
     * Validate selected outcome
     * @param {object} outcome
     * @returns {*}
     */
    validateBetOutcome(outcome) {
      this.foundOutcome = false;
      const existBetOutcome = this.activeBetType === 'single' ? this.validateBetOutcomeOnBetslip(outcome) : false;
      if (!outcome || Object.keys(outcome).length === 0) {
        // There is no searched outcome
        this.error.outcome = `${this.translations.outcome ? this.translations.outcome : 'outcome'} ${this.translations.isNotFound ? this.translations.isNotFound : 'isNotFound'}`;
        this.valid.outcome = false;
      } else if (existBetOutcome) {
        this.error.outcome = `${this.translations.outcome ? this.translations.outcome : 'outcome'} ${this.translations.outcomeExistInBetslip ? this.translations.outcomeExistInBetslip : 'outcomeExistInBetslip'}`;
        this.valid.outcome = false;
      } else {
        this.foundOutcome = true;
        // this.valid.match = true;
        // this.valid.bet = true;
        this.valid.outcome = true;
      }
      return outcome;
    },
    findOutcomeShortcut(id) {
      this.foundOutcome = false;
      Object.keys(this.selected.bet.betOutcomes).forEach((key) => {
        if (this.selected.bet.betOutcomes[key].outcomeShortcut === id) {
          this.inputs.outcomeOdd = this.selected.bet.betOutcomes[key].outcomeOdd;
          this.foundOutcome = true;
        }
      });
      return true;
    },
    selectBet(event) {
      const keyCode = (event.which) ? event.which : event.keyCode;
      const specIndex = this.search.specialBetVal.indexOf(this.inputs.defaultSpecBetVal);
      let selectedIndex = specIndex !== -1 ? specIndex : 0;
      this.inputs.defaultSpecBetVal = this.search.specialBetVal[selectedIndex];

      if (keyCode === 38) {
        if (this.search.specialBetVal[selectedIndex + 1]) {
          this.inputs.defaultSpecBetVal = this.search.specialBetVal[selectedIndex + 1];
          selectedIndex -= 1;
        }
      } else if (keyCode === 40) {
        if (this.search.specialBetVal[selectedIndex - 1]) {
          this.inputs.defaultSpecBetVal = this.search.specialBetVal[selectedIndex - 1];
          selectedIndex += 1;
        }
      }
      this.checkSpecBet(this.checkInputVal(this.inputs.defaultSpecBetVal));
      if (this.inputs.outcomeId.length > 0) {
        this.checkOutcome(this.checkInputVal(this.inputs.outcomeId));
      }
    },
    /**
     * Set focus on right input
     */
    setFocus(type) {
      if (type === 'match' && this.bets.length > 0 && !this.foundMatch) {
        // Set focus on payin input on betslip
        setTimeout(() => {
          document.getElementById('betslip-payin-input').focus();
        }, 0);
      } else if (type === 'match' && this.foundMatch) {
        // Set focus on bet input
        this.$refs['inputs.betId'].focus();
      } else if (type === 'bet' && this.foundBet && !this.foundSpecial) {
        // Set focus on outcome input
        this.$refs['inputs.outcomeId'].focus();
        if (this.inputs.outcomeId.length > 0) {
          // this.checkSpecBet(toNumber(this.inputs.defaultSpecBetVal));
          this.checkOutcome(toNumber(this.inputs.outcomeId));
        }
      } else if (type === 'bet' && this.foundBet && this.foundSpecial) {
        // Set focus on special bet input
        // betForm[index].focus();
        this.$refs['inputs.defaultSpecBetVal'].focus();
      } else if (type === 'specBet') {
        // Set focus on outcome input
        this.$refs['inputs.outcomeId'].focus();
      } else if (type === 'outcome') {
        this.sendToBetslip();
      }
    },
    /**
     * Try sending bet data to betslip
     */
    sendToBetslip() {
      this.disabledInputMatchId = true;
      const finalBet = this.validateBetData();
      const editedBet = this.selectedBet; // TODO

      if (finalBet.valid) {
        // const bet = finalBet.data;
        this.validatePreBetslip(finalBet, editedBet);
      }
      finalBet.error.msg = 'Error';
    },
    /**
     * Final bet data validation before sending to betslip
     *
     * @returns {Object} finalData
     */
    validateBetData() {
      this.validateFinalData(this.selected.match, this.selected.bet, this.selected.outcome);
      const finalData = Object.assign({}, this.tmpResponse);
      if (this.foundMatch && this.foundBet && this.foundOutcome) {
        finalData.data = new Ticket.Bet(
          this.selected.match,
          this.selected.bet,
          this.selected.outcome,
        );
        finalData.data.betExists = true;
        finalData.valid = true;
      } else {
        finalData.valid = false;
      }
      return finalData;
    },
    /**
     * Create final bet data
     *
     * @param {object} match
     * @param {object} bet
     * @param {object} outcome
     * @returns {object} finalTicket
     */
    validateFinalData(match, bet, outcome) {
      const finalTicket = {
        match: this.validateMatch(match),
        bet: this.validateMatchBet(bet),
        outcome: this.validateBetOutcome(outcome),
      };
      return finalTicket;
    },
    /**
     * Check rule for max number of bets on betslip
     *
     * @return {boolean} isBetCountValid
     */
    checkMaxBetCount() {
      let isBetCountValid = true;
      if (this.bets.length >= this.gameConfig.rules_maxBetCount) {
        const errorMessage = this.translations.maxNumBet || 'maxNumBet';
        const error = {
          action: 'Dialog.ShowModal',
          data: {
            action: '7S:Dialog.ShowModal',
            message: `${errorMessage} ${this.gameConfig.rules_maxBetCount}.`,
            type: 'warning',
            delay: 3000,
          },
        };
        isBetCountValid = false;
        this.sendMessage(error);
      }
      return isBetCountValid;
    },
    /**
     * Send bet data to betslip
     * Need to check edit mode
     *
     * @param {object} finalB
     * @param {boolean} editedBet
     */
    validatePreBetslip(finalB, editedBet) {
      const finalBet = finalB;
      if (editedBet) {
        finalBet.data.betUuid = this.editBet.data.betUuid;
        finalBet.index = this.editBet.index;

        if (this.editBet.data.betUuid === this.bets[finalBet.index].betUuid) {
          this.changeBet(finalBet);
        } else if (this.checkMaxBetCount()) {
          this.addBet(finalBet.data);
        }
      } else if (this.checkMaxBetCount()) {
        this.addBet(finalBet.data);
      }
      this.$store.commit('EDIT_BET', {});
      this.resetBetData();
    },
    /**
     * Reset active state
     */
    resetBetData() {
      this.enableMatchInput();
      Object.keys(this.inputs).forEach((i) => {
        this.inputs[i] = '';
      });
      this.clearSelected();
      this.foundMatch = false;
      this.foundBet = false;
      this.foundOutcome = false;
      this.foundSpecial = false;
      this.possibleBets = [];
      this.search.specialBetVal = [];
      this.search.possibleBets = [];
    },
    /**
     * Reset input values when selected match is not valid
     */
    resetValues() {
      this.inputs.betId = '';
      this.inputs.betName = '';
      this.inputs.defaultSpecBetVal = '';
      this.inputs.outcomeId = '';
      this.inputs.outcomeOdd = '';
      this.valid.match = false;
      this.valid.bet = false;
      this.valid.outcome = false;
      this.search.specialBetVal = [];
      this.search.possibleBets = [];
      this.clearSelected();
    },
    /**
     * Check is selected match already on betslip
     *
     * @param {number} id
     * @return {boolean}
     */
    checkBetslip(id) {
      this.foundMatchInBetslip = false;
      if (this.findMatch(id) && this.activeBetType === 'combo') {
        this.foundMatchInBetslip = true;
      }
      if (this.selectedBet) {
        this.foundMatchInBetslip = false;
      }
      return this.foundMatchInBetslip;
    },
    /**
     * Search bets by selected match id
     *
     * @param {number} id
     * @return {boolean}
     */
    findMatch(id) {
      this.checkMatchInBetslip = false;
      Object.keys(this.bets).forEach((i) => {
        if (this.bets[i].matchDisplayId === id) {
          this.checkMatchInBetslip = true;
        }
      });
      return this.checkMatchInBetslip;
    },
    /**
     * Add new outcome on betslip when betting preview is active
     *
     * @param {object} outcome
     */
    addOutcome(bet, outcome) {
      this.setBet(bet);
      this.setOutcome(outcome);
      this.sendToBetslip();
    },
  },
  watch: {
    editBet: {
      handler(newEdit) {
        // console.log(' *** editBet ', newEdit);
        if (Object.keys(newEdit).length > 0) {
          this.selectedBet = true;
          this.updateInputs(newEdit.data);
          /* this.checkMatch(newEdit.data.matchDisplayId);
          this.checkBet(newEdit.data.betDisplayId);
          this.checkOutcome(newEdit.data.betOutcomeShortcut); */
        } else {
          this.resetBetData();
          this.selectedBet = false;
        }
      },
    },
    activeBetType: {
      handler() {
        if (this.inputs.matchId.length > 0) {
          this.checkMatch(toNumber(this.inputs.matchId));
        }
      },
    },
    isGameActive: {
      handler() {
        this.enableMatchInput();
      },
    },
    keyEventTimestamp: {
      handler(newEvent) {
        const key = newEvent.split('_')[0];
        if (key === '/') {
          this.resetBetData();
          this.clearBets();
        }
      },
    },
  },
};
</script>
